(function () {
    'use strict';

    angular
        .module('vcreminder')
        .config(config);

    config.$inject = ['$stateProvider', '$logProvider'];

    function config($stateProvider, $log) {
        $stateProvider
            .state('playground.vcreminder', {
                url: '/vcreminder',
                views: {
                    'playgroundmain@playground': {
                        template: `
              <h3 class="alert alert-info"><tt>&lt;allreminders&gt;</tt></h3><div ui-view="allreminders"></div>
              <h3 class="alert alert-info"><tt>&lt;patientreminder patient=""&gt;</tt></h3><div ui-view="patientreminder"></div>
            `
                    }
                },
                onEnter: function ($log) {
                    $log.debug('debug/routes - playground.vcreminder entered');
                }
            });
        $stateProvider
            .state('playground.vcreminder.allcomponents', {
                url: '/allcomponents',
                resolve: {
                    reminder: function () {
                        return '';
                    },
                },
                views: {
                    // When `fooState.barState` is active, `fooComponent`
                    // is loaded into the <ui-view name='content' />
                    // which was created by `fooState`.
                    // The component's `foo` input receives `fooData` resolve
                    'allreminders@playground.vcreminder': {
                        component: 'allreminders',
                    },
                    'patientreminder@playground.vcreminder': {
                        component: 'patientreminder',
                        bindings: {
                            patient: 'patient'
                        }
                    }

                },
                onEnter: function () {
                    console.log('playground.vcreminder.allcomponents entered');
                }
            });


    }// all routes


}());